const NAMESPACE = 'PARAMS';
const INITIAL_STATE: AppParamState = {
  id : null,
  params: null,
  previousUrl: null
};

export const AppParamsActions = {
  INIT: `${NAMESPACE}.INIT`,
  SET_ID: `${NAMESPACE}.SET_ID`,
  SET_PARAMS: `${NAMESPACE}.SET_PARAMS`,
  SET_PREVIOUS_URL: `${NAMESPACE}.SET_PREVIOUS_URL`
};

export function AppParamsReducer(state: AppParamState = INITIAL_STATE, action: any) {
  switch (action.type) {
    case AppParamsActions.INIT:
      state = INITIAL_STATE;
      return state;
    case AppParamsActions.SET_ID:
      state.id = action.payload;
      return state;
    case AppParamsActions.SET_PARAMS:
      state.params = action.payload;
      return state;
    case AppParamsActions.SET_PREVIOUS_URL:
      state.previousUrl = action.payload;
      return state;
    default:
      return state;
  }
}

export interface AppParamState {
  id?: number;
  params?: any;
  previousUrl?: string;
}
